import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { shareReplay, switchMap } from 'rxjs/operators';

import { RoutingService } from 'src/app/services/routing.service';
import { UnitApplicationParentType } from 'src/app/shared/enums/unit-bank-account/UnitApplicationParentType.enum';
import AccountType from 'src/app/shared/enums/AccountType.enum';
import { UnitBankAccountReqRes } from 'src/app/shared/models/gp/UnitBankAccountReqRes.model';
import { UnitBankAccountFee } from 'src/app/shared/models/unit-bank-account/UnitBankAccountFee.model';
import { TerraUtils } from 'src/app/shared/TerraUtils';
import { UnitBankAccountService } from '../unit-bank-account.service';

@Component({
  selector: 'terra-unit-bank-account-pending-approval',
  templateUrl: './unit-bank-account-pending-approval.component.html',
  styleUrls: ['./unit-bank-account-pending-approval.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnitBankAccountPendingApprovalComponent implements OnInit {
  // consts
  generalServerErrorMessage: string = TerraUtils.consts.messages.GENERAL_SUBMIT_ERROR;
  UnitAccountType = AccountType;

  @Input('bankAccount') account: UnitBankAccountReqRes;
  UnitApplicationParentType = UnitApplicationParentType;

  @Input() userShouldApprove: boolean = false;

  fees$: Observable<any> = of(this.getFakeFees());

  processingSubmit$ = new BehaviorSubject(false);
  isSubmitAttempt$ = new BehaviorSubject(false);

  pageForm = this.fb.group({
    depositAgreement: [false, Validators.requiredTrue],
    termsOfServiceAgreement: [false, Validators.requiredTrue]
  });

  originUrl$: Observable<string>;

  isCreateFailed$ = new BehaviorSubject(false);

  constructor(
    private fb: FormBuilder,
    private routingService: RoutingService,
    private unitBankAccountService: UnitBankAccountService
  ) {
  }

  ngOnInit(): void {
    this.originUrl$ = of(this.account.unitApplication.parentType === UnitApplicationParentType.LP ? this.routingService.lpBankAccounts : this.routingService.bankAccountsPage("cre")).pipe(shareReplay(1));
  }

  approve() {
    this.isSubmitAttempt$.next(true);

    if (!this.pageForm.valid) {
      return;
    }

    this.processingSubmit$.next(true);
    this.unitBankAccountService.approve().subscribe(() => {
    },
      error => {
        this.processingSubmit$.next(false);
        this.isCreateFailed$.next(true);
      });
  }

  private getFakeFees(): UnitBankAccountFee[] {
    return [
      {
        type: 'Domestic Distributions Fee',
        description: 'Proin maximus sem ac libero convallis egestas.',
        fee: '0.01% of Amount'
      },
      {
        type: 'International Distributions Fee',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
        fee: '$5 monthly'
      },
      {
        type: 'Other Distributions Fee',
        description: 'Suspendisse molestie, ligula non consectetur viverra.',
        fee: '1% of Amount'
      }
    ];
  }
}


